import { render, staticRenderFns } from "./NavigationOperatoreCRoom.vue?vue&type=template&id=200cfa1a&scoped=true"
import script from "./NavigationOperatoreCRoom.vue?vue&type=script&lang=js"
export * from "./NavigationOperatoreCRoom.vue?vue&type=script&lang=js"
import style0 from "./NavigationOperatoreCRoom.vue?vue&type=style&index=0&id=200cfa1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200cfa1a",
  null
  
)

export default component.exports